import { BASE_URL } from "@/constants/endpoints";
import {
  RequestPolicy,
  RequestPolicyDetail,
} from "@/pages/config/request-policies/schema/request-policies.schema";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let requestPoliciesApiPromise: Promise<AxiosInstance> | null = null;

const getRequestPoliciesApi = async () => {
  if (requestPoliciesApiPromise) return requestPoliciesApiPromise;
  requestPoliciesApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return requestPoliciesApiPromise;
};

export const getTiposSolicitud = async () => {
  const api = await getRequestPoliciesApi();
  if (!api) return null;
  const response = await api.get(`/PoliticasSolicitud/GetTiposSolicitud`);
  return response.data;
};

export const getRequestPolicies = async (): Promise<RequestPolicy[] | null> => {
  const api = await getRequestPoliciesApi();
  if (!api) return null;
  const response = await api.get(
    `/PoliticasSolicitud/GetListadoPoliticasSolicitud`,
  );
  return response.data;
};

interface GetRequestPolicyProps {
  id: number;
}

export const getRequestPolicy = async (
  props: GetRequestPolicyProps,
): Promise<RequestPolicyDetail | null> => {
  const api = await getRequestPoliciesApi();
  if (!api) return null;
  const response = await api.get(
    `/PoliticasSolicitud/GetPoliticaSolicitud?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export interface CreateRequestPolicyProps {
  tipoSolicitud: number[];
  clase: string;
  nombre: string;
  valor: string;
}

export const createRequestPolicy = async (props: CreateRequestPolicyProps) => {
  const api = await getRequestPoliciesApi();
  if (!api) return null;
  const response = await api.post(
    `/PoliticasSolicitud?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export interface UpdateRequestPolicyProps {
  idPoliticaSolicitud: number;
  tipoSolicitud: number[];
  clase: string;
  nombre: string;
  valor: string;
  activo?: boolean;
}

export const updateRequestPolicy = async (props: UpdateRequestPolicyProps) => {
  const api = await getRequestPoliciesApi();
  if (!api) return null;
  const response = await api.put(
    `/PoliticasSolicitud?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export interface DeleteRequestPoliciesProps {
  ids: number[];
}

export const deleteRequestPolicies = async (
  props: DeleteRequestPoliciesProps,
) => {
  const api = await getRequestPoliciesApi();
  if (!api) return null;
  const response = await api.delete(
    `/PoliticasSolicitud?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};
